import React, { useContext } from "react";
import { ReviewContext } from "../context/ReviewContext";
import { getQuestionsCols } from "../Shared/Controller/projectReviewApp";
import RowQuestion from "./RowQuestion";

const DelinquencyQuestion = () => {
  const DelinquencyProps = useContext(ReviewContext);

  return (
    <React.Fragment>
      {DelinquencyProps.RowData.AllQuestions.delinquency_questions &&
        <div className={getQuestionsCols({ typesOfQuestion: Object.keys(DelinquencyProps.RowData.AllQuestions).length, type: "delinquency" }) + " mb-3"}>
          <div className="card-main">
            <h3>Delinquency</h3>
            {DelinquencyProps.RowData.AllQuestions.delinquency_questions.map((item, index) => {
              return (
                <React.Fragment key={item.id}>
                  <RowQuestion item={item}
                    answers={DelinquencyProps.answers}
                    setQuestionChoice={DelinquencyProps.setQuestionChoice}
                    setQuestionComment={DelinquencyProps.setQuestionComment}
                    reviewAnswerErrors={DelinquencyProps.reviewAnswerErrors}
                    userDetail={DelinquencyProps.userDetail}
                    take_ownership={DelinquencyProps.take_ownership}
                    integrity_review={DelinquencyProps.integrity_review}
                    index={index}
                  />
                </React.Fragment>
              )
            })
            }
          </div>
        </div>
      }
    </React.Fragment>
  )
}
export default DelinquencyQuestion;